import React, {Component} from 'react'
import PropType from 'prop-types'
import WorkerStatistics from "./WorkerStatistics"
import FilterStatus from "./FilterStatus";

class ChooseDevices extends Component {
    state = {
        current: 'd1'
    }

    _handleChangeDevice = e => {
        const {value} = e.target

        this.setState({
            current: value
        })

        this.props.onChange(value)
    }

    render() {
        return (
            <div className="ChooseDevices col-md-4 col-12">
                <label>Choose devices</label>

                <div className="form-group">
                    <select
                        className="form-control"
                        onChange={this._handleChangeDevice} value={this.state.current}>
                        <option value="d1">Computer 1</option>
                    </select>
                </div>

                <div className="row">
                    <FilterStatus onChangeStatus={this.props.onChangeStatus} status={this.props.status}/>

                    <WorkerStatistics/>
                </div>
            </div>
        )
    }
}

ChooseDevices.propTypes = {
    onChange: PropType.func.isRequired,
}

export default ChooseDevices



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/ChooseDevices.js